import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    getInstertitielCashbackUrl,
    displayableCashback,
    hasCashback,
    isMultiDiscount
} from '../../../services/partner/utils';
import { showModal } from '../../../services/modal/actions';
import { getPartner } from '../../../services/partner/selector';
import { MOMENTJS_DATE_FORMAT } from '../../../constants/moment';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';
import { getDiscountsByPartnerId } from '../../../services/discount/selector';
import PartnerBlockHorizontalComponent from '../../partner/PartnerBlockHorizontalComponent';

const DELAI_VALIDATION_DEFAULT = 15;

class HeaderComponent extends React.Component {
    showLoginModal = () => event => {
        const { isAuthenticated, showModal } = this.props;

        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    renderCashback = () => {
        const { i18nPartner, partner, mostDisplayableDiscountOnline = {} } = this.props;

        if (partner && hasCashback(partner)) {
            const {
                percent,
                fixed,
                initialPercent,
                initialFixed
            } = partner.mostDisplayableDiscountOnline;
            const initialCashback = displayableCashback(initialPercent, initialFixed);
            const { label } = mostDisplayableDiscountOnline;

            return (
                <div className="cashback">
                    <span className="upTo">
                        {isMultiDiscount(this.props.partner) && `${this.props.i18nPartner.jusqua} `}
                    </span>
                    <span>
                        <span className="value">
                            {displayableCashback(percent, fixed)} {i18nPartner.rembourse}
                            {(percent > 1 || fixed > 1) && 's'}
                        </span>
                    </span>
                    &nbsp;
                    {label || (
                        <React.Fragment>
                            {i18nPartner.DEFAULT_DISCOUNT_LABEL}
                            {initialCashback && (
                                <span className="olieu grey">
                                    &nbsp;
                                    {i18nPartner.aulieude} {initialCashback}
                                </span>
                            )}
                        </React.Fragment>
                    )}
                </div>
            );
        } else {
            return <div>{i18nPartner.pasdecashbackencemoment}</div>;
        }
    };

    // render the estimated date validation block
    renderEstimatedValidationDate = () => {
        const { partner, ESTIMATED_VALIDATION_DATE } = this.props;
        const validationDelay = partner ? partner.validationDelay : DELAI_VALIDATION_DEFAULT;
        const estimatedValidationDate = moment()
            .locale('nl')
            .add(validationDelay, 'days')
            .format(MOMENTJS_DATE_FORMAT);

        return partner && partner.validationDelay > -1 && hasCashback(partner) ? (
            <div className="small">
                {`${ESTIMATED_VALIDATION_DATE} `}
                <br className="show-mobonly" />
                <strong>{estimatedValidationDate}</strong>
            </div>
        ) : null;
    };

    render() {
        const { partner, i18nPage } = this.props;
        const url = getInstertitielCashbackUrl(partner);

        return (
            <PartnerBlockHorizontalComponent partner={partner} noLogoLink cssClass="fm-entete">
                <div className="fm-entete-offre-bt grid has-gutter flex-center-alt">
                    <div className="fm-entete-offre">
                        {this.renderCashback()}
                        {this.renderEstimatedValidationDate()}
                    </div>
                    <div className="fm-entete-bt one-third flex-container-v">
                        {hasCashback(partner) && (
                            <LinkButtonComponent
                                color="fifth"
                                text={i18nPage.TAKETHEOFFER}
                                title={i18nPage.TAKETHEOFFER}
                                to={url}
                                target="_blank"
                                onClick={this.showLoginModal()}
                            />
                        )}
                    </div>
                </div>
            </PartnerBlockHorizontalComponent>
        );
    }
}

HeaderComponent.propTypes = {
    id: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const partner = getPartner(state, ownProps.id);
    const discountId =
        partner && partner.id && partner.mostDisplayableDiscountOnline
            ? partner.mostDisplayableDiscountOnline.discountId
            : -1;
    const mostDisplayableDiscountOnline = (
        getDiscountsByPartnerId(state, ownProps.id) || []
    ).filter(discount => discount.id === discountId)[0];
    return {
        partner,
        mostDisplayableDiscountOnline,
        i18nPartner: state.i18n.feature.partenaire,
        i18nPage: state.i18n.page.MERCHANTCARD,
        isAuthenticated: state.authentication.isAuthenticated,
        ESTIMATED_VALIDATION_DATE: state.i18n.page.MERCHANTCARD.ESTIMATED_VALIDATION_DATE,
        BUTTON_CASHBACK: state.i18n.page.MERCHANTCARD.BUTTON_CASHBACK
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/HeaderComponent.js